///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component } from '@angular/core';
import { UserAuthorities } from '../services/user/user-authorities';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SystemInfoDTO } from '../generated/shared-types.model';
import { selectSystemInfo } from '../shared/store/systemInfo/system-info.selectors';

@Component({
    selector: 'winde-home',
    templateUrl: './home.component.html',
    styleUrls: ['home.component.scss'],
    standalone: false
})
export class HomeComponent {
    userAuthorities = UserAuthorities;

    public systemInfo$: Observable<SystemInfoDTO> = this.store.select(selectSystemInfo);

    constructor(private readonly store: Store) {}
}
